<template>
  <v-card>
    <v-card-title primary-title>
      <div class="headline blue--text">{{title}}</div>
    </v-card-title> 
    <v-container>
      <v-layout row wrap px-3>
        <v-flex xs12 text-xs-center style="margin-top: -24px;">
          <span class="grey--text" v-html="loadingText"></span>
        </v-flex>
        <v-flex xs12 align-center justify-space-between>
          <v-text-field
            v-model="record_info.name"
            prepend-icon="perm_identity"
            placeholder="Nome"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="record_info.cpf_cnpj"
            prepend-icon="picture_in_picture"
            placeholder="CPF/CNPJ"></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="totalDebit"
            prepend-icon="money"
            readonly
            disabled
            placeholder="Saldo"></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-textarea
            label="Anotações"
            auto-grow
            rows="1"
            v-model="record_info.notes"></v-textarea>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="white" class="grey--text" @click="$router.go(-1)">Cancelar</v-btn>
      <v-btn color="blue darken-2" dark @click="saveRecord()">{{saveBtnLabel}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
  name: "ClientForm",
  components: { },
  props: {
    record: Object
  },
  data() {
    return { balance: null, record_info: {}, loading: false }
  },
  computed: {
    loadingText() {
      return this.loading ? 'Carregando...' : '&nbsp;'
    },
    totalDebit() {
      return (this.balance !== null) ? this.balance : 'Calculando saldo...'
    },
    title() {
      return this.updateState ? 'Cadastro do Cliente' : 'Cadastrar Cliente'
    },
    clientId() {
      const route_check_result = pathToRegexp('/cliente/:id*').exec(this.$route.path)
      return route_check_result === null ? null : route_check_result[1];
    },
    updateState() {
      return this.clientId ? (this.clientId === 'novo' ? false : true) : false
    },
    saveBtnLabel() {
      return (this.updateState) ? 'Atualizar' : 'Salvar'
    }
  },
  methods: {
    checkRoute(string_route) {
      return pathToRegexp(string_route).exec(this.$route.path) !== null;
    },
    saveRecord() {
      let successCallback = (response) => {
        this.$router.go(-1)
      }

      let errorCallback = (response) => {
        debugger
      }

      let payload = {
        name: this.record_info.name,
        cpf_cnpj: this.record_info.cpf_cnpj,
        notes: this.record_info.notes,
        business_id: 1
      }

      if (this.updateState) {
        this.$http.put(`${this.$root.base_url}/customers/${this.clientId}`, payload, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
      } else {
        this.$http.post(`${this.$root.base_url}/customers`, payload, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
      }
    },
    loadRecord() {
      this.loading = true

      let successCallback = (response) => {
        if (response.body.data) {
          this.loading = false
          this.record_info = response.body.data[0]
        }
      }

      let errorCallback = (response) => {
        debugger
      }

      this.$http.get(`${this.$root.base_url}/customers/${this.clientId}`, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
    }
  },
  created() {
    this.record_info = this.record
    if (typeof this.record.id !== 'undefined') {
      this.loading = false
    }
    this.$root.$on('CUSTOMER_TOTAL_DEBIT', (total) => {
      this.balance = total
    })
  },
  mounted() {
    if ((this.clientId) && (typeof(this.record_info.id) === 'undefined')) {
      this.loadRecord()
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mecanica/ClientForm.vue